import Component from './Component'

export default class TinyMCE extends Component {

	static _type = 'TinyMCE'

	form			// Parent form component

	input_el		// DOM Elements
	feedback_el

	editor			// TinyMCE.Editor instance

	tether () {
		super.tether()

		// Own DOM elements
		this.input_el = this.base.querySelector('textarea')
		this.feedback_el = this.base.querySelector('.invalid-feedback')

		// Enclosing form
		this.form = this.base.closest('form[anvil-component]').anvil
		//this.form.registerInput(this.params.name, this)

		// Initialize extension
		let options = {
			selector: '_' + this.input_el.id,
			menubar: false,
			statusbar: false,
			language: 'hu_HU',
			content_css: "css/tinymce_content.css",
			setup: (editor) => {
				this.editor = editor
			}
		}

		if ('height' in this.params) options.height = this.params.height
		tinymce.init(options)

		// Create bound event handlers and register them
		this.inputListener = TinyMCE._inputListener.bind(this)
		this.updateListener = TinyMCE._updateListener.bind(this)

		this.editor.on('change', this.inputListener)									// TinyMCE event
		this.form.data.record.on(this.params.name + '-updated', this.updateListener)	// node event
	}

	static _inputListener () {
		// Send data to the record
		this.form.data[this.params.name] = this.editor.getContent()
	}

	static _updateListener (value, errors) {

		// If the value changed, update it on the input as well
		if (this.editor.getContent() != value) {
			this.editor.setContent(value)
		}

		// Render validation
		this.renderValidation(errors)

		// Update hook
		if ('update' in this.params && typeof this.params.update == 'function') {
			this.params.update(value, this.params.name, this.form.data, this.params)
		}
	}

	renderValidation (errors) {
		if (errors == null) {
			// Validation successful
			$(this.input_el).removeClass('is-invalid')
			$(this.feedback_el).html('')
		} else {
			// Invalid
			$(this.input_el).addClass('is-invalid')
			$(this.feedback_el).html(errors.join('<br />'))
		}
	}

	destroy () {

		// Unregister event handlers
		this.editor.off('input', this.inputListener)
		this.form.data.record.off(this.params.name + '-updated', this.updateListener)

		// Remove editor instance
		tinymce.remove('_' + this.input_el.id);

		delete this.input_el
		delete this.feedback_el
		delete this.form

		super.destroy()
	}
}
